// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wJ2Ee","textarea":"styles_textarea__3OX6s"};